import { vkIconsMap } from "./vkIcons.js";
import * as __rspack_external__additionalIcons_index_js_afd702de from "./additionalIcons/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const additionalIconsMap = {
    vkhrtek_code: {
        16: __rspack_external__additionalIcons_index_js_afd702de.CodeIcon
    },
    vkhrtek_code_block: {
        16: __rspack_external__additionalIcons_index_js_afd702de.CodeBlockIcon
    },
    vkhrtek_justify_format: {
        16: __rspack_external__additionalIcons_index_js_afd702de.JustifyFormatIcon
    },
    vkhrtek_omega: {
        16: __rspack_external__additionalIcons_index_js_afd702de.OmegaIcon
    },
    vkhrtek_reference: {
        16: __rspack_external__additionalIcons_index_js_afd702de.ReferenceIcon
    },
    vkhrtek_subscript: {
        16: __rspack_external__additionalIcons_index_js_afd702de.SubscriptIcon
    },
    vkhrtek_superscript: {
        16: __rspack_external__additionalIcons_index_js_afd702de.SuperscriptIcon
    },
    vkhrtek_video_link: {
        20: __rspack_external__additionalIcons_index_js_afd702de.VideoLinkIcon
    },
    vkhrtek_company_page: {
        20: __rspack_external__additionalIcons_index_js_afd702de.SidebarCompanyPageIcon
    },
    vkhrtek_vacations_page: {
        20: __rspack_external__additionalIcons_index_js_afd702de.SidebarVacationsPageIcon
    },
    vkhrtek_add_section: {
        24: __rspack_external__additionalIcons_index_js_afd702de.AddSectionIcon
    },
    vkhrtek_add_link: {
        24: __rspack_external__additionalIcons_index_js_afd702de.AddLinkIcon
    },
    vkhrtek_vacation: {
        14: __rspack_external__additionalIcons_index_js_afd702de.VacationIcon
    },
    vkhrtek_visibility_off: {
        16: __rspack_external__additionalIcons_index_js_afd702de.VisibilityOffIcon
    },
    vkhrtek_maternity_leave: {
        16: __rspack_external__additionalIcons_index_js_afd702de.MaternityLeaveIcon
    },
    vkhrtek_medical: {
        16: __rspack_external__additionalIcons_index_js_afd702de.MedicalIcon
    },
    vkhrtek_absence: {
        16: __rspack_external__additionalIcons_index_js_afd702de.AbsenceIcon
    },
    vkhrtek_separate_unit: {
        16: __rspack_external__additionalIcons_index_js_afd702de.SeparateUnitIcon
    },
    vkhrtek_schedule_syncron: {
        16: __rspack_external__additionalIcons_index_js_afd702de.ScheduleSyncronIcon
    },
    vkhrtek_file: {
        56: __rspack_external__additionalIcons_index_js_afd702de.FileIcon
    },
    vkhrtek_award: {
        48: __rspack_external__additionalIcons_index_js_afd702de.AwardIcon
    },
    vkhrtek_gender: {
        48: __rspack_external__additionalIcons_index_js_afd702de.GenderIcon
    },
    vkhrtek_man: {
        48: __rspack_external__additionalIcons_index_js_afd702de.ManIcon
    },
    vkhrtek_woman: {
        48: __rspack_external__additionalIcons_index_js_afd702de.WomanIcon
    },
    vkhrtek_task_list: {
        40: __rspack_external__additionalIcons_index_js_afd702de.TaskListIcon
    },
    vkhrtek_system_message: {
        24: __rspack_external__additionalIcons_index_js_afd702de.SystemMessageIcon
    },
    vkhrtek_download_file: {
        16: __rspack_external__additionalIcons_index_js_afd702de.DownloadFileIcon
    },
    vkhrtek_gosuslugi: {
        24: __rspack_external__additionalIcons_index_js_afd702de.GosUslugiIcon
    },
    vkhrtek_done_bordered: {
        64: __rspack_external__additionalIcons_index_js_afd702de.DoneBorderedIcon
    },
    vkhrtek_vk_pointer: {
        56: __rspack_external__additionalIcons_index_js_afd702de.VkPointerIcon
    },
    vkhrtek_xml_file: {
        95: __rspack_external__additionalIcons_index_js_afd702de.XmlFileIcon
    },
    vkhrtek_sig_file: {
        95: __rspack_external__additionalIcons_index_js_afd702de.SigFileIcon
    },
    vkhrtek_export_xlsx: {
        16: __rspack_external__additionalIcons_index_js_afd702de.ExportXlsxIcon
    },
    vkhrtek_energy_important: {
        20: __rspack_external__additionalIcons_index_js_afd702de.EnergyImportantIcon
    },
    vkhrtek_dots_vertical_disabled: {
        24: __rspack_external__additionalIcons_index_js_afd702de.DotsVerticalDisabledIcon
    },
    vkhrtek_add_link_item: {
        20: __rspack_external__additionalIcons_index_js_afd702de.AddLinkIcon
    },
    vkhrtek_add_section_item: {
        20: __rspack_external__additionalIcons_index_js_afd702de.AddSectionIcon
    },
    vkhrtek_drag_disabled: {
        24: __rspack_external__additionalIcons_index_js_afd702de.DragDisabledIcon
    },
    vkhrtek_at: {
        16: __rspack_external__additionalIcons_index_js_afd702de.AtIcon
    },
    vkhrtek_stage_error: {
        16: __rspack_external__additionalIcons_index_js_afd702de.StageErrorIcon
    },
    vkhrtek_stage_checked: {
        16: __rspack_external__additionalIcons_index_js_afd702de.StageCheckedIcon
    },
    vkhrtek_slider_outline: {
        16: __rspack_external__additionalIcons_index_js_afd702de.SliderOutlineIcon
    },
    vkhrtek_edit_circle_outline: {
        16: __rspack_external__additionalIcons_index_js_afd702de.EditCircleOutlineIcon
    },
    vkhrtek_circle_outline: {
        16: __rspack_external__additionalIcons_index_js_afd702de.CircleOutlineIcon
    },
    vkhrtek_employee_info: {
        20: __rspack_external__additionalIcons_index_js_afd702de.EmployeeInfo
    },
    vkhrtek_app_gallery: {
        24: __rspack_external__additionalIcons_index_js_afd702de.AppGalleryIcon
    },
    vkhrtek_app_store: {
        24: __rspack_external__additionalIcons_index_js_afd702de.AppStoreIcon
    },
    vkhrtek_google_play: {
        24: __rspack_external__additionalIcons_index_js_afd702de.GooglePlayIcon
    },
    vkhrtek_ru_store: {
        24: __rspack_external__additionalIcons_index_js_afd702de.RuStoreIcon
    },
    vkhrtek_filter_filled: {
        24: __rspack_external__additionalIcons_index_js_afd702de.FilterFilledIcon
    },
    vkhrtek_status_in_progress: {
        16: __rspack_external__additionalIcons_index_js_afd702de.StatusInProgressIcon
    },
    vkhrtek_rectangles_2_outline: {
        24: __rspack_external__additionalIcons_index_js_afd702de.Rectangles2Outline
    },
    vkhrtek_absence_3d: {
        48: __rspack_external__additionalIcons_index_js_afd702de.Absence3DIcon
    },
    vkhrtek_benefits_3d: {
        48: __rspack_external__additionalIcons_index_js_afd702de.Benefits3DIcon
    },
    vkhrtek_candidates_3d: {
        48: __rspack_external__additionalIcons_index_js_afd702de.Candidates3DIcon
    },
    vkhrtek_competencies_3d: {
        48: __rspack_external__additionalIcons_index_js_afd702de.Competencies3DIcon
    },
    vkhrtek_event_3d: {
        48: __rspack_external__additionalIcons_index_js_afd702de.Event3DIcon
    },
    vkhrtek_payroll_3d: {
        48: __rspack_external__additionalIcons_index_js_afd702de.Payroll3DIcon
    },
    vkhrtek_review_3d: {
        48: __rspack_external__additionalIcons_index_js_afd702de.Review3DIcon
    },
    vkhrtek_structure_3d: {
        48: __rspack_external__additionalIcons_index_js_afd702de.Structure3DIcon
    },
    vkhrtek_training_3d: {
        48: __rspack_external__additionalIcons_index_js_afd702de.Training3DIcon
    },
    vkhrtek_businesstrip_3d: {
        48: __rspack_external__additionalIcons_index_js_afd702de.Businesstrip3DIcon
    },
    vkhrtek_payslips_3d: {
        48: __rspack_external__additionalIcons_index_js_afd702de.Payslips3DIcon
    },
    vkhrtek_personal_3d: {
        48: __rspack_external__additionalIcons_index_js_afd702de.Personal3DIcon
    },
    vkhrtek_policy_3d: {
        48: __rspack_external__additionalIcons_index_js_afd702de.Policy3DIcon
    },
    vkhrtek_statements_3d: {
        48: __rspack_external__additionalIcons_index_js_afd702de.Statements3DIcon
    },
    vkhrtek_clock_circle: {
        16: __rspack_external__additionalIcons_index_js_afd702de.ClockCircleIcon
    },
    vkhrtek_transparency_outline_2: {
        20: __rspack_external__additionalIcons_index_js_afd702de.TransparencyOutline2Icon
    }
};
const icons = _object_spread({}, vkIconsMap, additionalIconsMap);
export default icons;
export { additionalIconsMap };
